import React, { useState } from "react";
import "./RequestDetailsByCustmer.css";
import { Avatar, Card, Col, Image, Row, Typography } from "antd";
import {
  FileOutlined,
  FilePdfOutlined,
  FileExcelOutlined,
  FileWordOutlined,
} from "@ant-design/icons";
import { ReactComponent as TableShopIcon } from "../../assets/icons/TableShopicon.svg";
import { baseUrl } from "../../commonUtils/commonUtils";
import RequestDetailsByCustmerModal from "../Modal/RequestDetailsByCustmerModal/RequestDetailsByCustmerModal";
const { Title, Text } = Typography;

const IMAGE_EXTENSIONS = ["jpg", "jpeg", "png"];
const EXCEL_EXTENSIONS = ["xls", "xlsx"];
const WORD_EXTENSIONS = ["doc", "docx"];

const getFileExtension = (url) => {
  if (!url || typeof url !== "string") return "";
  const cleanUrl = url.split("?")[0];
  const parts = cleanUrl.split(".");
  return parts.length > 1 ? parts.pop().toLowerCase() : "";
};

const isImageUrl = (url) => IMAGE_EXTENSIONS.includes(getFileExtension(url));

const getFileIcon = (url) => {
  const extension = getFileExtension(url);
  if (extension === "pdf") return <FilePdfOutlined />;
  if (EXCEL_EXTENSIONS.includes(extension)) return <FileExcelOutlined />;
  if (WORD_EXTENSIONS.includes(extension)) return <FileWordOutlined />;
  return <FileOutlined />;
};

const getItemListText = (productDetails) => {
  if (Array.isArray(productDetails)) {
    return productDetails
      .map((item) =>
        typeof item === "string" ? item : item?.product_name || item?.name || ""
      )
      .filter(Boolean)
      .join(", ");
  }
  if (typeof productDetails === "string") {
    return productDetails;
  }
  return "";
};

const getPreferredBrandsText = (preferredBrands) => {
  if (Array.isArray(preferredBrands)) {
    return preferredBrands.filter(Boolean).join(", ");
  }
  if (typeof preferredBrands === "string") {
    const trimmedBrands = preferredBrands.trim();
    if (trimmedBrands.startsWith("[") && trimmedBrands.endsWith("]")) {
      return trimmedBrands
        .slice(1, -1)
        .split(",")
        .map((brand) => brand.trim().replace(/^['"]|['"]$/g, ""))
        .filter(Boolean)
        .join(", ");
    }
    return trimmedBrands;
  }
  return "";
};

const SPECIFIC_PREFERENCES_NOTE_ID = "specific_preferences_note";

const getCommentsText = (questionnaireAnswers) => {
  const commentItem = (questionnaireAnswers || []).find(
    (item) => item?.question_id === SPECIFIC_PREFERENCES_NOTE_ID
  );
  return commentItem?.answer_label || commentItem?.answer || "";
};

const getDeliveryInstructions = (questionnaireAnswers) =>
  (questionnaireAnswers || []).filter(
    (item) => item?.question_id !== SPECIFIC_PREFERENCES_NOTE_ID
  );

const TruncatableText = ({ text, isExpanded, onToggle }) => {
  if (!text) return null;
  if (text.length < 250) {
    return <span>{text}</span>;
  }
  return (
    <>
      {isExpanded ? text : `${text.slice(0, 250)}...`}
      <span style={{ color: "blue", cursor: "pointer" }} onClick={onToggle}>
        {isExpanded ? " View less" : " View more"}
      </span>
    </>
  );
};

const isRequestedItem = (item) =>
  item &&
  typeof item === "object" &&
  !Array.isArray(item) &&
  ("quote_item_id" in item ||
    "product_name" in item ||
    "mob_sku" in item);

const getRequestedItems = (items) => {
  if (Array.isArray(items)) {
    return items.filter(isRequestedItem);
  }

  if (!items || typeof items !== "object") {
    return [];
  }

  if (isRequestedItem(items)) {
    return [items];
  }

  return Object.values(items).filter(isRequestedItem);
};

const RequestDetailsByCustmer = (props) => {
  console.log("🚀 ~ RequestDetailsByCustmer ~ props:", props)
  const {
    listData,
    isMagicQuote = false,
  } = props;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);
  const [isItemListExpanded, setIsItemListExpanded] = useState(false);
  const [isBrandsExpanded, setIsBrandsExpanded] = useState(false);
  const [isCommentsExpanded, setIsCommentsExpanded] = useState(false);

  const requestedItemGroups = Object.entries(
    listData?.quote_requesteditems || {}
  )
    .map(([vendorKey, items]) => [vendorKey, getRequestedItems(items)])
    .filter(([, items]) => items.length > 0);

  

  const totalCount = requestedItemGroups.reduce(
    (total, [, items]) =>
      total +
      items.reduce((subtotal, item) => {
        const quantity = Number(item?.qty);
        return subtotal + (Number.isFinite(quantity) ? quantity : 0);
      }, 0),
    0
  );
  const handleToggleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  const productCheck =
    listData && listData?.product_details
      ? Object.keys(listData?.product_details)?.length
      : 0;
  const handleOpenModal = () => {
    setIsModalOpen(true);
  };
  const handlePdfDownload = (pdfURL) => {
    const pdfUrl = `${baseUrl}${pdfURL}`;
    window.open(pdfUrl, "_blank");
  };
  const colorSizeList = listData?.product_details?.variant_info || [];

  const mobSkuDetails = () => {
    if (colorSizeList?.length === 0) {
      return [];
    }
    let detailArray = [];
    colorSizeList?.map((item) => {
      for (let key in item) {
        detailArray.push({ label: key, value: item[key] });
      }
      return null;
    });
    return detailArray;
  };

  const attachmentFiles = Array.isArray(listData?.files) ? listData.files : [];
  const itemListText = getItemListText(listData?.rfq_remarks);
  const preferredBrandsText = getPreferredBrandsText(listData?.preferred_brands);
  const commentsText = getCommentsText(listData?.questionnaire_answers);
  const deliveryInstructions = getDeliveryInstructions(
    listData?.questionnaire_answers
  );
  const hasItemsSelectedSection =
    attachmentFiles.length > 0 ||
    itemListText ||
    preferredBrandsText ||
    commentsText ||
    deliveryInstructions.length > 0;
  const handleFileOpen = (fileUrl) => {
    window.open(fileUrl, "_blank");
  };
  return (
    <>
      {!isMagicQuote && (
        <Card
          className="request-customer-card"
          style={{
            boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.16)",
          }}
        >
          <Col className="tittle-card">
            <Title
              level={3}
              style={{
                margin: 0,
                color: "#0A243F",
                fontSize: "18px",
                fontWeight: 600,
                lineHeight: "26px",
              }}
            >
              Items Requested by the customer
            </Title>
          </Col>
          {productCheck === 0 ? (
            <Row
              style={{
                display: "flex",
                gap: "24px",
                padding: "0 24px 24px 24px",
              }}
            >
              {listData?.rfq_file && (
                <Col
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    width: "100%",
                    height: "52px",
                    padding: " 14px 16px",
                    borderRadius: "8px",
                    backgroundColor: "#f5f5f5",
                    color: " #2973f0",
                  }}
                >
                  <Col
                    style={{
                      display: "flex",
                      gap: "0.5rem",
                      alignItems: "center",
                    }}
                  >
                    <FileOutlined />
                    <Text style={{ color: " #2973f0" }}>
                      {/* {rfq_file?.toUpperCase()} */}
                    </Text>
                  </Col>
                  <Text
                    style={{ color: " #2973f0", cursor: "pointer" }}
                    onClick={() => handlePdfDownload(listData?.rfq_file)}
                  >
                    View
                  </Text>
                </Col>
              )}
              {listData?.rfq_remarks && (
                <Col>
                  <Title level={5} style={{ margin: "0 0 1rem 0" }}>
                    COMMENTS
                  </Title>
                  {listData?.rfq_remarks && (
                    <>
                      {listData?.rfq_remarks.length < 250 ? (
                        <span>{listData?.rfq_remarks}</span>
                      ) : (
                        <>
                          {isExpanded
                            ? listData?.rfq_remarks
                            : `${listData?.rfq_remarks.slice(0, 250)}...`}
                          <span
                            style={{ color: "blue", cursor: "pointer" }}
                            onClick={handleToggleExpand}
                          >
                            {isExpanded ? " View less" : " View more"}
                          </span>
                        </>
                      )}
                    </>
                  )}

                  {/* <Text style={{}}>{listData?.rfq_remarks}</Text> */}
                </Col>
              )}
            </Row>
          ) : (
            <>
              <Col className="request-customer-component-1">
                <Col className="component-avatar">
                  <Avatar
                    shape="square"
                    style={{
                      backgroundColor: "#f3f2ef",
                      borderRadius: "16px",
                    }}
                    size={60}
                    icon={<TableShopIcon style={{ marginTop: "12px" }} />}
                  />
                  <Col className="component-text-container">
                    <Text className="text-1">
                      {listData?.product_details?.vendor_name}
                    </Text>
                    <Text className="text-2">
                      BMPID: {listData?.product_details?.bmp_id}
                    </Text>
                  </Col>
                </Col>
                <Text className="text-3" onClick={() => handleOpenModal()}>
                  View seller details
                </Text>
              </Col>
              <Col className="request-customer-component-2">
                <Col className="component-avatar-2">
                  <Avatar
                    shape="square"
                    style={{
                      backgroundColor: "#f3f2ef",
                      borderRadius: "16px",
                    }}
                    size={80}
                    src={`${baseUrl}${listData?.product_details?.image}`}
                    icon={<TableShopIcon style={{ marginTop: "12px" }} />}
                  />
                  <Col className="component-text-container-2">
                    <Text className="text-heading">
                      {listData?.product_details?.product_name}
                    </Text>
                    <Text className="text-2" style={{ marginTop: "10px" }}>
                      MOBSKU: {listData?.product_details?.mob_sku}
                    </Text>
                    {mobSkuDetails()?.map((item) => {
                      return (
                        <>
                          <Text className="text-color">
                            {item?.label}:{" "}
                            <Text className="text-color-in">{item?.value}</Text>
                          </Text>
                        </>
                      );
                    })}
                  </Col>
                </Col>
                <Text className="text-color">
                  Qty:{" "}
                  <Text className="text-color-in">
                    {listData?.product_details?.quantity}
                  </Text>
                </Text>
              </Col>
              {listData?.rfq_remarks && (
                <Col className="comment-container">
                  <Title level={5} style={{ margin: "0 0 1rem 0" }}>
                    COMMENTS
                  </Title>
                  {listData?.rfq_remarks && (
                    <>
                      {listData?.rfq_remarks.length < 250 ? (
                        <span>{listData?.rfq_remarks}</span>
                      ) : (
                        <>
                          {isExpanded
                            ? listData?.rfq_remarks
                            : `${listData?.rfq_remarks.slice(0, 250)}...`}
                          <span
                            style={{ color: "blue", cursor: "pointer" }}
                            onClick={handleToggleExpand}
                          >
                            {isExpanded ? " View less" : " View more"}
                          </span>
                        </>
                      )}
                    </>
                  )}

                  {/* <Text style={{}}>{listData?.rfq_remarks}</Text> */}
                </Col>
              )}

              <RequestDetailsByCustmerModal
                isModalOpen={isModalOpen}
                setIsModalOpen={setIsModalOpen}
                listData={listData}
              />
            </>
          )}
        </Card>
      )}

      {listData?.auto_generated &&
        requestedItemGroups.length > 0 && (
          
          <Card
            className="rfq-customer-card"
            style={{
              boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.16)",
            }}
          >
            <Col className="tittle-card" style={{borderBottom:"1px solid #dedede"}}>
              <Title
                level={3}
                style={{
                  margin: 0,
                  color: "#0A243F",
                  fontSize: "18px",
                  fontWeight: 600,
                  lineHeight: "26px",
                }}
              >
                {totalCount} items <span style={{ fontWeight: "400",fontSize:"16px" }}> (
                {requestedItemGroups.length} suborder
                request)</span>
              </Title>
            </Col>
            {listData?.rfq_remarks && (
            <Col className="comment-container" style={{marginTop:"12px"}}> 
              <Title level={5} style={{ margin: "0 0 2rem 0" }}>
                COMMENTS
              </Title>
              {listData?.rfq_remarks && (
                <>
                  {listData?.rfq_remarks.length < 250 ? (
                    <span>{listData?.rfq_remarks}</span>
                  ) : (
                    <>
                      {isExpanded
                        ? listData?.rfq_remarks
                        : `${listData?.rfq_remarks.slice(0, 250)}...`}
                      <span
                        style={{ color: "blue", cursor: "pointer" }}
                        onClick={handleToggleExpand}
                      >
                        {isExpanded ? " View less" : " View more"}
                      </span>
                    </>
                  )}
                </>
              )}

              {/* <Text style={{}}>{listData?.rfq_remarks}</Text> */}
            </Col>
          )}
            <Col className="quote-requested-items">
              {requestedItemGroups.map(([vendorKey, items]) => {
                return (
                  <Col key={vendorKey} className="vendor-section ">
                    <Col className="rfq-heading-bmp">
                      <Text className="text-heading-rfqquote">
                        Mob partner: {vendorKey}
                      </Text>
                    </Col>
                    {items.map((item, index) => {
                      return (
                        <Row
                          gutter={[16, 16]}
                          key={index}
                          className="quote-item d-flex"
                        >
                          <Col span={20}>
                            {/* <img src={item.product_image} alt={item.product_name} style={{ width: '50px', height: '50px', marginRight: '10px' }} /> */}
                            <Text>
                              {item?.product_name}
                              <br />
                              <span className="text-lightfont-rfqquote">
                                MOBSKU:{item?.mob_sku}{" "}
                              </span>
                            </Text>
                          </Col>
                          <Col className="text-right" span={4}>
                            <Text>
                              <span className="text-lightfont-rfqquote">
                                Qty:{" "}
                              </span>
                              <br />
                              <span>{item?.qty}</span>
                            </Text>
                          </Col>
                        </Row>
                      );
                    })}
                  </Col>
                );
              })}
            </Col>
          </Card>
        )}

      {hasItemsSelectedSection && isMagicQuote && (
        <Card className="rfq-customer-card items-selected-card">
          <Col className="tittle-card items-selected-title-card">
            <Title level={3} className="items-selected-card-title">
              Items Requested by the customer
            </Title>
          </Col>
          <Col className="items-selected-content">
            {attachmentFiles.length > 0 && (
              <Col className="attachment-thumbnail-list">
                {attachmentFiles.map((fileUrl, index) =>
                  isImageUrl(fileUrl) ? (
                    <Image
                      key={index}
                      src={fileUrl}
                      alt={`attachment-${index}`}
                      className="attachment-thumbnail-image"
                      wrapperClassName="attachment-thumbnail"
                    />
                  ) : (
                    <Col
                      key={index}
                      className="attachment-thumbnail attachment-file"
                      onClick={() => handleFileOpen(fileUrl)}
                    >
                      {getFileIcon(fileUrl)}
                    </Col>
                  )
                )}
              </Col>
            )}
            {itemListText && (
              <Col className="items-selected-section">
                <Title level={5} className="items-selected-section-title">
                  Item list
                </Title>
                <Text>
                  <TruncatableText
                    text={itemListText}
                    isExpanded={isItemListExpanded}
                    onToggle={() => setIsItemListExpanded(!isItemListExpanded)}
                  />
                </Text>
              </Col>
            )}
            {preferredBrandsText && (
              <Col className="items-selected-section">
                <Title level={5} className="items-selected-section-title">
                  Preferred brands
                </Title>
                <Text>
                  <TruncatableText
                    text={preferredBrandsText}
                    isExpanded={isBrandsExpanded}
                    onToggle={() => setIsBrandsExpanded(!isBrandsExpanded)}
                  />
                </Text>
              </Col>
            )}
            {commentsText && (
              <Col className="items-selected-section">
                <Title level={5} className="items-selected-section-title">
                  Comments
                </Title>
                <Text>
                  <TruncatableText
                    text={commentsText}
                    isExpanded={isCommentsExpanded}
                    onToggle={() => setIsCommentsExpanded(!isCommentsExpanded)}
                  />
                </Text>
              </Col>
            )}
            {deliveryInstructions.length > 0 && (
              <Col className="items-selected-section">
                <Title level={5} className="items-selected-section-title">
                  Delivery instructions
                </Title>
                {deliveryInstructions.map((item) => (
                  <Text key={item?.question_id} className="text-color">
                    {item?.question}:{" "}
                    <Text className="text-color-in">
                      {item?.answer_label || item?.answer}
                    </Text>
                  </Text>
                ))}
              </Col>
            )}
          </Col>
        </Card>
      )}
    </>
  );
};

export default RequestDetailsByCustmer;
